import { useState } from "react";
import { ArrowUp, Mic, ChevronDown } from "lucide-react";


import HamburgerMenu from "../../assets/hamburger.svg";
import ShortLogo from "../../assets/short-logo.svg";
import SocratesVideo from "../../assets/socrates.mp4";

export default function ChatPage() {
  const [tutorStyle, setTutorStyle] = useState("Socrates");
  const [progress, setProgress] = useState(0);
  const [input, setInput] = useState("YES!!");
  const [messages, setMessages] = useState([
    {
      id: 1,
      role: "tutor",
      content:
        "Hello, young thinker. Are you ready for a journey where questions are more powerful than answers?",
    },
  ]);

  const handleSend = () => {
    if (!input.trim()) return;
    setMessages((m) => [...m, { id: Date.now(), role: "user", content: input.trim() }]);
    setInput("");
    setProgress((p) => Math.min(p + 5, 100));
  };

  return (
    <div className="max-w-md mx-auto px-4 py-6 flex flex-col h-screen bg-white">
      {/* Header */}
      <header className="flex items-center justify-between mb-6">
        <img src={ShortLogo} alt="Short Logo" className="w-9 h-9" />
        <img src={HamburgerMenu} alt="Hamburger Menu" className="w-7 h-7" />
      </header>

      {/* Title */}
      <h1 className="text-[1.25rem] font-semibold leading-snug mb-4">
        Algebra <span className="font-normal text-gray-500">(High school level)</span>
      </h1>

      {/* Tutor style select */}
      <div className="relative w-48 mb-6">
  <select
    value={tutorStyle}
    onChange={(e) => setTutorStyle(e.target.value)}
    className="appearance-none bg-[#F5F8FF] rounded-lg px-3 pr-10 py-2 text-sm focus:outline-none focus:ring-0 w-full"
  >
    <option value="Socrates">Tutor style: Socrates</option>
    <option value="Aristotle">Tutor style: Aristotle</option>
    <option value="Einstein">Tutor style: Einstein</option>
  </select>
  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" />
</div>

      {/* Lesson progress */}
      <div className="mb-4">
        <p className="text-base font-medium mb-1">
          Lesson 1 <span className="text-gray-500">(appx 30min to complete)</span>
        </p>
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
        <p className="text-xs text-gray-500 mt-1">{progress}%</p>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto space-y-6 py-2">
        {messages.map((m) =>
          m.role === "tutor" ? (
            <TutorBubble key={m.id} content={m.content} />
          ) : (
            <UserBubble key={m.id} content={m.content} />
          )
        )}
      </div>

      {/* Composer */}
      <div className="mt-4">
        <div className="flex items-end gap-2 bg-blue-50 rounded-2xl px-4 py-3">
          <textarea
            rows={2}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your message…"
            className="flex-1 bg-transparent outline-none resize-none text-base"
          />
          <button className="p-2 text-blue-600 hover:text-blue-700">
            <Mic className="w-5 h-5" />
          </button>
          <button
            onClick={handleSend}
            className="p-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full"
          >
            <ArrowUp className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}

function TutorBubble({ content }: { content: string }) {
  return (
    <div className="flex items-start gap-3">
      <video
        src={SocratesVideo}
        className="w-10 h-10 rounded-full object-cover"
        muted
        loop
        autoPlay
      />
      <div className="bg-white border border-gray-300 rounded-2xl p-5 shadow-sm max-w-[85%]">
        <p className="text-lg leading-relaxed">{`“${content}”`}</p>
      </div>
    </div>
  );
}

function UserBubble({ content }: { content: string }) {
  return (
    <div className="flex justify-end">
      <div className="bg-blue-600 text-white rounded-2xl p-4 max-w-[80%]">
        <p className="text-base">{content}</p>
      </div>
    </div>
  );
}
